import { observable, action } from 'mobx';
import intl from 'react-intl-universal';
import {
    signIn,
    signOut,
    getItems,
    downloadFileWithUrl,
    getUserInfo,
    updateFile,
    createFolder,
    createFile,
    uploadFileToSharepoint,
    isSignInDrive,
    isUploadFilePending,
    isUpdateFilePending,
    isDownloadFilePending,
    cancelOpenFileRequest,
    cancelUploadFileRequest,
    cancelUpdatedFileRequest,
    getOneDriveFileByUrl,
    redirectToGoogleOAuth,
    signInForGSuite,
    getFileFromFileHandler,
    getFileHandlerState,
    refreshTokenForSharePoint,
    webHookSubscribeForSharePoint, listFolder, listFiles, initTokenByRefreshToken,
} from 'Api/drives.api';
import {store} from 'Store/store.index';
import {
  DOCUMENT_SAVE_FAILED,
} from 'Components/viewer/ui/constants/event.constants';
import { storageGetItem, storageSetItem } from '@/utils/utils';
import { fileController } from 'Components/viewer/Controllers/index';
import { DRIVES_FILE_SIZE_LIMIT } from '@/limit.constant';
import { sharePointService } from './services/index';

const category = 'CloudDrive'

export default class DriveStore {
  @observable saveType = null
  @observable funType = null
  @observable iManageInfo = {
    isFromIManage: false,
    isSaveBackToIManage: false,
    loc: null,
    item: null,
  }
  @observable onCloseDrivesDlgForCombineFiles = null
  @observable onAddFilesForAddPanel = null
  @observable sharePointRefreshTokenInfo = {
    grant_type: "refresh_token",
    refresh_token: null,
    client_id: null,
    client_secret: null
  }
  @observable sharePointAutoSavingFlag = false
  @observable sharePointRefreshTokenTimer = null
  @observable sharePointAutoSaveTimer = null
  @observable fileFrom = null  // officeFileHandler
  @observable fileHandlerToken = null
    // https://foxitsoftwareinc.sharepoint.com/sites/OneDriveFileHandlerTest/_api/Web/getfolderbyserverrelativeurl('/sites/OneDriveFileHandlerTest/Shared Documents/IvesFolder')/files/add(overwrite=true, url='test_file.pdf')

  // {
  //   "@odata.context": "https://graph.microsoft.com/v1.0/$metadata#shares('u%21aHR0cHM6Ly9mb3hpdHNvZnR3YXJlaW5jLnNoYXJlcG9pbnQuY29tL3NpdGVzL09uZURyaXZlRmlsZUhhbmRsZXJUZXN0L1NoYXJlZCUyMERvY3VtZW50cy8yMjIlMjAtJTIwJUU1JTg5JUFGJUU2JTlDJUFDLnBkZj90ZW1wYXV0aD1leUowZVhBaU9pSktWMVFpTENKaGJHY2lPaUp1YjI1bEluMC5leUpoZFdRaU9pSXdNREF3TURBd015MHdNREF3TFRCbVpqRXRZMlV3TUMwd01EQXdNREF3TURBd01EQWlMQ0pwYzNNaU9pSXdNREF3TURBd015MHdNREF3TFRCbVpqRXRZMlV3TUMwd01EQXdNREF3TURBd01EQWlMQ0p1WW1ZaU9pSXhOalE0TURnNE1qUXhJaXdpWlhod0lqb2lNVFkwT0RFM05EWTBNU0lzSW1WdVpIQnZhVzUwZFhKc0lqb2lOamxvY0V0dk9GQlVhazlwT0ZCakt6WnZkMng1V1ZSUmRGUm1jMDlXY21sUGJXbFVSV1UwV0Zsb1l6MGlMQ0psYm1Sd2IybHVkSFZ5YkV4bGJtZDBhQ0k2SWprNUlpd2lZMmxrSWpvaVRUSkdhVnBVU21wWlZFRjBUbXBDYTA1cE1IaE5SRUYzVEZSQk1rMVVhM1JaVjBVeFRrZFplRTV0U1RCTmVrSnBJaXdpYzJsMFpXbGtJam9pVGxSak1GcEhSbTFaVjFGMFRVZGFiRTVETURCWlZFMDFURlJuTlU5VVZYUlBSR3N5VG5wWk1rNTZZM2haVkdzMElpd2lkbVZ5SWpvaWFHRnphR1ZrY0hKdmIyWjBiMnRsYmlJc0ltRndjR2xrSWpvaVlUaGhabVpoTmpjdE1qQTNZaTAwTlRBMkxUZzJaakl0Tldaa056RmpaVEV4T1RKaklpd2lkR2xrSWpvaU1qazRZelE0WkRBdFpqVTFOeTAwTlRZeExXSTFOR1F0TVdKbVptVmtNV1EyWWpjMElpd2lkSFFpT2lJekluMC5VelV2YWxSaFpWZGtWVk5FS3pkQmNVNUhMM2hDT0RoeGJ6RjRWREYwVm5SVVFubHlkRTVGVnprNFRUMA')/driveItem/$entity",
  //   "@microsoft.graph.downloadUrl": "https://foxitsoftwareinc.sharepoint.com/sites/OneDriveFileHandlerTest/_layouts/15/download.aspx?UniqueId=16ada83a-325c-4714-83e0-eca5515675e4&Translate=false&tempauth=eyJ0eXAiOiJKV1QiLCJhbGciOiJub25lIn0.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAvZm94aXRzb2Z0d2FyZWluYy5zaGFyZXBvaW50LmNvbUAyOThjNDhkMC1mNTU3LTQ1NjEtYjU0ZC0xYmZmZWQxZDZiNzQiLCJpc3MiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAiLCJuYmYiOiIxNjQ4MDg4Mjc2IiwiZXhwIjoiMTY0ODA5MTg3NiIsImVuZHBvaW50dXJsIjoicGlla1ZCaktZNXBNeFlkU1dMeEZMaHBFQ0NsWVYrNmJTOHNWS0V2NWZtVT0iLCJlbmRwb2ludHVybExlbmd0aCI6IjE1NyIsImlzbG9vcGJhY2siOiJUcnVlIiwiY2lkIjoiWXpReVlUaG1PREF0TnpWbU1DMDBZMlprTFRrMFl6UXROVGs1WW1JNFlqaGpaakZrIiwidmVyIjoiaGFzaGVkcHJvb2Z0b2tlbiIsInNpdGVpZCI6Ik5UYzBaR0ZtWVdRdE1HWmxOQzAwWVRNNUxUZzVPVFV0T0RrMk56WTJOemN4WVRrNCIsImFwcF9kaXNwbGF5bmFtZSI6Ik9uZURyaXZlIEZpbGVIYW5kbGVyIERldiIsImdpdmVuX25hbWUiOiJGb3hpdCIsImZhbWlseV9uYW1lIjoiU29mdHdhcmUiLCJzaWduaW5fc3RhdGUiOiJbXCJrbXNpXCJdIiwiYXBwaWQiOiJhOGFmZmE2Ny0yMDdiLTQ1MDYtODZmMi01ZmQ3MWNlMTE5MmMiLCJ0aWQiOiIyOThjNDhkMC1mNTU3LTQ1NjEtYjU0ZC0xYmZmZWQxZDZiNzQiLCJ1cG4iOiJhcHBzdG9yZUBmb3hpdHNvZnR3YXJlaW5jLm9ubWljcm9zb2Z0LmNvbSIsInB1aWQiOiIxMDAzQkZGRDkyREY4RkQ2IiwiY2FjaGVrZXkiOiIwaC5mfG1lbWJlcnNoaXB8MTAwM2JmZmQ5MmRmOGZkNkBsaXZlLmNvbSIsInNjcCI6ImFsbGZpbGVzLndyaXRlIGFsbGZpbGVzLndyaXRlIGFsbHNpdGVzLnJlYWQgYWxscHJvZmlsZXMucmVhZCIsInR0IjoiMiIsInVzZVBlcnNpc3RlbnRDb29raWUiOm51bGwsImlwYWRkciI6IjIwLjE5MC4xNTcuMjcifQ.TUNKSHp5WEtYWjlPeklqdHMxMXA1WU5HSGhwOXpLelE3S25ibktnalFrMD0&ApiVersion=2.0",
  //   "createdDateTime": "2021-07-20T03:36:39Z",
  //   "eTag": "\"{16ADA83A-325C-4714-83E0-ECA5515675E4},1\"",
  //   "id": "01NKKV6KJ2VCWRMXBSCRDYHYHMUVIVM5PE",
  //   "lastModifiedDateTime": "2021-07-20T03:36:39Z",
  //   "name": "222 - 副本.pdf",
  //   "webUrl": "https://foxitsoftwareinc.sharepoint.com/sites/OneDriveFileHandlerTest/Shared%20Documents/222%20-%20%E5%89%AF%E6%9C%AC.pdf",
  //   "cTag": "\"c:{16ADA83A-325C-4714-83E0-ECA5515675E4},1\"",
  //   "size": 4940,
  //   "createdBy": {
  //     "user": {
  //       "email": "appstore@foxitsoftwareinc.onmicrosoft.com",
  //       "displayName": "Foxit"
  //     }
  //   },
  //   "lastModifiedBy": {
  //     "user": {
  //       "email": "appstore@foxitsoftwareinc.onmicrosoft.com",
  //       "displayName": "Foxit"
  //     }
  //   },
  //   "parentReference": {
  //     "driveId": "b!ra9NV-QPOUqJlYlnZncamFFKjt0nafxPvZDSJkqcm-hhNk5rmZVfR41tGizqGP3i",
  //     "driveType": "documentLibrary",
  //     "id": "01NKKV6KN6Y2GOVW7725BZO354PWSELRRZ",
  //     "path": "/drives/b!ra9NV-QPOUqJlYlnZncamFFKjt0nafxPvZDSJkqcm-hhNk5rmZVfR41tGizqGP3i/root:"
  //   },
  //   "file": {
  //     "mimeType": "application/pdf",
  //     "hashes": {
  //       "quickXorHash": "srEcTXaZ4mzQJAZTnQgnh/zR7i0="
  //     }
  //   },
  //   "fileSystemInfo": {
  //     "createdDateTime": "2021-07-20T03:36:39Z",
  //     "lastModifiedDateTime": "2021-07-20T03:36:39Z"
  //   }
  // }
  @observable googleDriveFilesInfoArr = []

  @observable sharepointFilesInfoArr = []
  @observable numberOfAjaxCAllPending = 0;
  @observable userAccount = '';
  // file list data
  @observable filesData = [];
  // is sign in to a certain drive
  @observable isSignIn = false;
  @observable modalType = ''
  @observable operateType = '';
  @observable driveModalContentHeight = '';
  @observable loading = false;
  @observable driveName = '';

  @observable lastOpenDriveName = '';

  @observable openFileInfo = {
    driveName: '',
    fileName: '',
    fileId: null,
    folderPath: null,
    item: null,
  };

  @observable driveData = {
    data: [],
    folderPath: [],
    userAccount: null,
  };

  @observable showDrivesPanel = false;
  @observable isOpenedFromDrive = false;
  /**
   *@brief function
   *       {id, driveName,fileName, buffer}
   *
   * @memberof DriveStore
   */
  @observable callback = null;
  @observable onSaveFileByMyself = null;
  @observable onResetAjaxCAllPending = null;
  @observable onNumberOfAjaxCAllPendingDecrease = null;
  @observable onNumberOfAjaxCAllPendingIncrease = null;
  @action updateSaveType(value) {
    this.saveType = value
  }
  @action resetSaveType() {
    this.saveType = null
  }
  @action updateFunType(value) {
    this.funType = value
  }
  @action resetFunType() {
    this.funType = null
  }
  @action updateIManageInfo(info) {
    Object.assign(this.iManageInfo, info)
  }
  @action resetIManageInfo() {
    this.iManageInfo = {
      isFromIManage: false,
      isSaveBackToIManage: false,
      loc: null,
      item: null
    }
  }
  @action setOnCloseDrivesDlgForCombineFiles(method) {
    this.onCloseDrivesDlgForCombineFiles = method
  }
  @action resetOnCloseDrivesDlgForCombineFiles() {
    this.onCloseDrivesDlgForCombineFiles = null
  }
  @action setOnAddFilesForAddPanel(method) {
    this.onAddFilesForAddPanel = method
  }
  @action updateModalType(value) {
    this.modalType = value
  }
  @action resetModalType() {
    this.modalType = ''
  }  
  @action updateOperateType(value) {
    this.operateType = value
  }
  @action resetOperateType() {
    this.operateType = ''
  }  
  @action updateSharePointAutoSavingFlag(flag) {
    this.sharePointAutoSavingFlag = flag
  }
  @action resetSharePointAutoSavingFlag() {
    this.sharePointAutoSavingFlag = false
  }
  @action async sharePointRefreshTokenHandler(timerFun) {
    try {
      const res = await this.refreshTokenForSharePoint()
      const {access_token, refresh_token} = res

      if (access_token && refresh_token) {
        this.updateSharepointToken(access_token)
        this.updateSharePointRefreshTokenInfo({refresh_token})
        timerFun && timerFun()
      }
    } catch (error) {
      console.error(error);
    }
  }
  @action leaveSharePointEditMode() {
    this.resetFileFrom()
    this.resetSharepointToken()
    this.resetSharepointFilesInfoArr()
    this.resetSharePointAutoSaveTimer()
    this.resetSharePointRefreshTokenTimer()
    this.resetSharePointRefreshTokenInfo()
    this.resetSharePointAutoSavingFlag()
    sharePointService.cleanIntervalForFileMetaData()
    store.historyStore.push({pathname:'/', search:''})
    store.appStore.resetSharePointInfo()
  }
  @action updateSharePointRefreshTokenInfo(info) {
    Object.assign(this.sharePointRefreshTokenInfo, info)
  }
  @action resetSharePointRefreshTokenInfo() {
    this.sharePointRefreshTokenInfo = {
      grant_type: "refresh_token",
      refresh_token: null,
      client_id: null,
      client_secret: null
    }
  }
  @action updateSharePointRefreshTokenTimer(timerFlag) {
    this.sharePointRefreshTokenTimer = timerFlag
  }
  @action resetSharePointRefreshTokenTimer() {
    clearTimeout(this.sharePointRefreshTokenTimer)
    this.sharePointRefreshTokenTimer = null
  }
  @action updateSharePointAutoSaveTimer(timerFlag) {
    this.sharePointAutoSaveTimer = timerFlag
  }
  @action resetSharePointAutoSaveTimer() {
    clearInterval(this.sharePointAutoSaveTimer)
    this.sharePointAutoSaveTimer = null
  }
  @action updateFileFrom(from) {
    this.fileFrom = from
  }
  @action resetFileFrom() {
    this.fileFrom = null
  }
  @action updateSharepointToken(sharepointToken) {
    this.fileHandlerToken = sharepointToken
  }
  @action resetSharepointToken() {
    this.fileHandlerToken = null
  }
  @action updateSharepointFilesInfoArr(filesInfoArr) {
    this.sharepointFilesInfoArr = filesInfoArr
  }
  @action resetSharepointFilesInfoArr() {
    this.sharepointFilesInfoArr = []
  }
  @action updateGoogleDriveFilesInfoArr(filesInfoArr) {
    this.googleDriveFilesInfoArr = filesInfoArr
  }
  @action resetGoogleDriveFilesInfoArr() {
    this.googleDriveFilesInfoArr = []
  }
  @action numberOfAjaxCAllPendingIncrease() {
    this.numberOfAjaxCAllPending++;
  }
  @action numberOfAjaxCAllPendingDecrease() {
    this.numberOfAjaxCAllPending !== 0 && this.numberOfAjaxCAllPending--;
  }
  @action resetNumberOfAjaxCAllPending() {
    this.numberOfAjaxCAllPending = 0;
  }
  @action setDriveName(driveName) {
    this.driveName = driveName;
  }
  @action setLoadingState(state) {
    this.loading = state;
  }
  @action setOpenFileInfo({ driveName, fileName, id, folderPath, item }) {
    this.openFileInfo = Object.assign(this.openFileInfo, {
      driveName,
      fileName,
      id,
      folderPath,
      item,
    });
  }
  @action setIsOpenedFromDrive(value) {
    this.isOpenedFromDrive = value;
  }
  @action doDeleteUserInDriveTokenInfo(driveName, user) {
    const allDriveTokenInfo = JSON.parse(storageGetItem(localStorage, 'driveTokenInfo'))
    const driveTokenInfo = allDriveTokenInfo[driveName]

    driveTokenInfo.splice(
      driveTokenInfo.findIndex((item) => item.userAccount === user.userAccount),
      1,
    );

    allDriveTokenInfo[driveName] = driveTokenInfo
    storageSetItem(localStorage, 'driveTokenInfo', JSON.stringify(allDriveTokenInfo))
  }
  @action doGetUserInfo({ driveName, success, fail }) {
    getUserInfo(
      driveName,
      (res) => {
        success && success(res);
      },
      (error) => {
        fail && fail(error);
        store.appStore.doPostError({
          level:'warn',
          category,
          data:{message: 'get user info failed', reason: !!error ? error : '', driveName}
        })
      },
    );
  }
  @action doGetItems({ driveName, folderId, success, fail }) {
    getItems(
      driveName,
      folderId,
      (res) => {
        success && success(res);
      },
      (error) => {
        fail && fail(error);
        store.appStore.doPostError({
          level:'warn',
          category,
          data:{message: 'get file list failed', reason: !!error ? error : '', driveName}
        })
      },
    );
  }
  @action doSignOut(driveName, success) {
    signOut(driveName, () => {
      success && success();
    });
  }
  @action doAuthorization({ driveName, success, fail, closeWin }) {
    signIn(
      driveName,
      (data) => {
        success && success(data);
      },
      (error) => {
        fail && fail(error);
        store.appStore.doPostError({
          level:'warn',
          category,
          data:{message: 'get token failed', reason: !!error ? error : '', driveName}
        })
      },
      () => {
        closeWin && closeWin()
      }
    );
  }
  @action doAuthorizationForGSuite(success) {
    signInForGSuite(success)
  }
  @action doOpenFile(driveName, item, success, fail) {
    // const { driveName } = this;

    downloadFileWithUrl(
      driveName,
      item,
      ({ blob, id, fileName, parents }) => {
        success && success({ blob, id, fileName, parents });
      },
      (error) => {
        fail && fail({ error });
        store.appStore.doPostError({
          level:'warn',
          category,
          data:{message: 'open file failed', reason: !!error ? error : '', driveName}
        })
      },
    );
  }
  @action doDownloadFile(driveName, item, success, fail) {
    downloadFileWithUrl(
      driveName,
      item,
      ({ blob, id, fileName }) => {
        success && success({ blob, id, fileName });
      },
      (error) => {
        store.appStore.doPostError({
          level:'warn',
          category,
          data:{message: 'open file failed', reason: !!error ? error : '', driveName}
        })
        fail && fail({ error });
      },
    );
  }
  @action doUpdateFile({ driveName, record, fileBlob, success, fail,mimeType }) {
    updateFile(
      driveName,
      record,
      fileBlob,
      (res) => {
        success && success(res);
      },
      (error) => {
        store.appStore.doPostError({
          level:'warn',
          category,
          data:{message: 'update file failed', reason: !!error ? error : '', driveName}
        })
        store.userStore.doSendGAEvent({eventKey: DOCUMENT_SAVE_FAILED, label:'doc_event'})
        fail && fail(error);
      },
      null,
      mimeType
    );
  }
  @action doCreateFile({ driveName, fileBlob, folderPath, success, fail, mimeType, fileType, libraryName, folderId, doc_profile }) {
    return createFile({
      driveName,
      fileBlob,
      folderPath,
      success: (res) => {
        success && success(res);
      },
      fail: (error) => {
        fail && fail(error);
        store.appStore.doPostError({
          level: 'warn',
          category,
          data: { message: 'create file failed', reason: !!error ? error : '', driveName },
        });
        store.userStore.doSendGAEvent({ eventKey: DOCUMENT_SAVE_FAILED, label: 'doc_event' });
      },
      progress: null,
      mimeType,
      fileType,
      libraryName,
      folderId,
      doc_profile
    });
  }
  @action doCancelOpenFileRequest(driveName) {
    // const { driveName } = this;

    cancelOpenFileRequest(driveName);
  }
  @action doCancelUploadFileRequest(driveName) {
    // const { driveName } = this;

    cancelUploadFileRequest(driveName);
  }
  @action doCancelUpdateFileRequest(driveName) {
    cancelUpdatedFileRequest(driveName);
  }
  @action async isSignInDrive(driveName) {
    let isSignIn = await isSignInDrive(driveName);

    return isSignIn;
  }
  @action async initTokenByRefreshToken(params){
     const result = await initTokenByRefreshToken(params);
     return result;
  }
  @action isUploadFilePending(driveName) {
    let result = isUploadFilePending(driveName);

    return result;
  }
  @action isUpdateFilePending(driveName) {
    let result = isUpdateFilePending(driveName);

    return result;
  }
  @action isDownloadFilePending(driveName) {
    let result = isDownloadFilePending(driveName);

    return result;
  }

  // todo wyl getOneDriveFileByUrl
  @action getOneDriveFileByUrl(shareUrl,success,fail){
    getOneDriveFileByUrl(shareUrl,success, (error) => {
      fail && fail(error)
      store.appStore.doPostError({
        level:'warn',
        category,
        data:{message: 'open shared file failed', reason: !!error ? error : '', driveName: 'OneDrive'}
      })
    });
  }

  @action getOneDriveFileByUrlForTeamsApp(shareUrl,success,fail){
    getOneDriveFileByUrl(shareUrl,success, (error) => {
      fail && fail(error)
      store.appStore.doPostError({
        level:'warn',
        category,
        data:{message: 'open shared file failed', reason: !!error ? error : '', driveName: 'OneDrive'}
      })
    });
  }
  @action redirectToGoogleOAuth(fileParams) {
    redirectToGoogleOAuth(fileParams)
  }
  @action getFileFromFileHandler(url, token) {
    return getFileFromFileHandler(url, token)
  }
  @action getFileHandlerState(stateId) {
    return getFileHandlerState(stateId)
  }
  @action setOnSaveFileByMyself(method){
    this.onSaveFileByMyself =  method
  }
  @action setNumberOfAjaxCAllPendingIncrease(method){
    this.onNumberOfAjaxCAllPendingIncrease = method
  }
  @action setNumberOfAjaxCAllPendingDecrease(method){
    this.onNumberOfAjaxCAllPendingDecrease = method
  }
  @action setResetNumberOfAjaxCAllPending(method){
    this.onResetAjaxCAllPending = method
  }
  @action saveCombinedFileBackToDrive(fileBlob) {
    return this.saveFileBackToDrive(fileBlob)
  }
  @action async saveFileBackToDrive(doc) {
    const fileBlob = doc || await fileController.getCurrentDocStream(0)

    if (fileBlob.size > 1024 * 1024 * DRIVES_FILE_SIZE_LIMIT) {
      store.appStore.setGlobalMessage({type: 'error', content: intl.formatMessage({ id: 'FileOverSize' })})

      return;
    }

    let folderPath

    return uploadFileToSharepoint({fileBlob, folderPath}).then((res) => {
      sharePointService.updateLastModifiedDateTime(res.lastModifiedDateTime)
      
      return res
    }).catch(() => {
      this.sharePointRefreshTokenHandler()
      throw new Error('upload file to sharepoint error')
    })
  }
  @action async saveFileBackToGoogleDrive(doc) {
    const {
      googleDriveInfo: { isConverted },
    } = store.appStore;
    const { googleDriveFilesInfoArr } = store.driveStore;
    const fileBlob = doc || (await fileController.getCurrentDocStream(0));

    if (!isConverted) {
      return updateFile('Google Drive', googleDriveFilesInfoArr[0], fileBlob);
    }

    fileBlob.name = googleDriveFilesInfoArr[0].name;

    return createFile({ driveName: 'Google Drive', fileBlob, folderPath: googleDriveFilesInfoArr[0].folderPath });
  }
  @action async refreshTokenForSharePoint() {
    return refreshTokenForSharePoint()
  }
  @action webHookSubscribeForSharePoint() {    
    return webHookSubscribeForSharePoint()
  }
  @action doCreateFolder(params) {
    return createFolder(params)
  }

  @action doListFolder(params){
    return listFolder(params);
  }

  @action doListFiles(params){
    return listFiles(params);
  }
}
